.SelectItem {
}
.SelectItem:hover {
  outline: none;
  background-color: #f1f1f1;
}

.SelectItem[data-highlighted] {
  outline: none;
  background-color: #f1f1f1;
}

.Trigger {
  background-color: #fff;
  transition: 0.15s background-color;
}
.Trigger:hover {
  background-color: #f1f1f1;
}

.SelectContent {
  width: var(--radix-select-trigger-width);
  max-height: var(--radix-select-content-available-height);
}
